export default "__VITE_ASSET__a360570d__"